<div class="w-full grid grid-cols-1" #prodPageContainer>
    <div>
        <ngx-datatable
            #ngxDatatable
            class="bootstrap"
            [rows]="ngx.dt.rows"
            [columnMode]="ngx.dt.column.mode"
            [headerHeight]="50"
            [footerHeight]="0"
            rowHeight="auto"
        >
            <ngx-datatable-column
                *ngFor="let column of ngx.dt.column.header"
                [name]="column.name"
                [flexGrow]="column.props.flexGrow"
                [sortable]="column.props.sortable"
                [prop]="column.key"
            >
                <ng-template
                    let-rowIndex="rowIndex"
                    let-row="row"
                    ngx-datatable-cell-template
                >
                    <ng-container [ngSwitch]="column.key">
                        <ng-container *ngSwitchDefault>
                            {{ column.render(row) }}
                        </ng-container>
                    </ng-container>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
    </div>
</div>
